import './spinner.styles.css';

export const Spinner = () => {
	return <p className="spinner" />;
};
